module.exports = __webpack_public_path__ + "static/01-2b540b058e7ebd90281eed7e995a2e8c.jpg";